import cs from 'classnames';
import type { FC } from 'react';
import { Accordion, Container } from '@/DesignSystem/Component';
import { IconAngleTop } from '@/Module/Icon';
import CertificateList from './CertificateList';
const headerContent = <div className="flex cursor-pointer items-center justify-between bg-blueTwo">
    <span className="inline-flex flex-1  px-6 py-4 font-bold text-blueFive">گواهی‌ها</span>
    <IconAngleTop className={cs('text-blueFive transition-all duration-300 ease-in-out group-[.ui--is-open]:rotate-180')} />
  </div>;
const bodyContent = <CertificateList className="mb-4" />;
export const DefaultLayoutFooterMiddle: FC = () => {
  return <div className="border-4 border-blueFive bg-blueTwo md:py-4 " data-sentry-component="DefaultLayoutFooterMiddle" data-sentry-source-file="DefaultLayoutFooterMiddle.tsx">
      <Container className="hidden  flex-col md:flex" data-sentry-element="Container" data-sentry-source-file="DefaultLayoutFooterMiddle.tsx">
        <CertificateList data-sentry-element="CertificateList" data-sentry-source-file="DefaultLayoutFooterMiddle.tsx" />
      </Container>
      <Accordion header={headerContent} className="flex flex-col bg-blueTwo md:hidden " data-sentry-element="Accordion" data-sentry-source-file="DefaultLayoutFooterMiddle.tsx">
        {bodyContent}
      </Accordion>
    </div>;
};